import NeighborhoodsGallery from "./NeighborhoodsGallery"
import NeighborhoodsContentCard from "./NeighborhoodsContentCard"

const NeighborhoodsCard = ({ data, noStartingPrice }: { data: any, noStartingPrice: boolean }) => {
	
	return ( 
		<div className="neighborhoods_container || lg:max-h-screen lg:h-[100vh] flex flex-col items-center gap-2 lg:flex-row lg:justify-between">
			<div className="w-[100%] h-[60vh] lg:w-[33%] lg:h-full">
				<NeighborhoodsGallery gallery={data?.gallery} />
			</div>
			<div className="lg:w-[32%]">
				<NeighborhoodsContentCard data={
					{
						title: data?.name?.en,
						desc: data?.description?.en,
						info: data?.info,
						slug: data?.slug
					}
				} noStartingPrice={noStartingPrice}/>
			</div>
		</div>
	)
}

export default NeighborhoodsCard